// import {useEffect, useState} from 'react';
//
// interface locationType {
//     loaded: boolean;
//     coordinates?: { readonly accuracy: number;
//         readonly altitude: number | null;
//         readonly altitudeAccuracy: number | null;
//         readonly heading: number | null;
//         readonly latitude: number;
//         readonly longitude: number;
//         readonly speed: number | null; };
//     error?: { code: number; message: string };
// }
//
// const useGeolocation = () => {
//
//     const [location, setLocation] = useState<locationType>({
//         loaded: false, coordinates: {accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, latitude: 0, longitude: 0, speed: 0}
//     })
//
//     // 성공에 대한 로직
//     const onSuccess = (position: { coords: { readonly accuracy: number;
//             readonly altitude: number | null;
//             readonly altitudeAccuracy: number | null;
//             readonly heading: number | null;
//             readonly latitude: number;
//             readonly longitude: number;
//             readonly speed: number | null; }; }) => {
//         setLocation({
//             loaded: true, coordinates: {
//                 accuracy: position.coords.accuracy,
//                 altitude: position.coords.altitude,
//                 altitudeAccuracy: position.coords.altitudeAccuracy,
//                 heading: position.coords.heading,
//                 latitude: position.coords.latitude,
//                 longitude: position.coords.longitude,
//                 speed: position.coords.speed
//
//             }
//         })
//     }
//
//     // 에러에 대한 로직
//     const onError = (error: { code: number; message: string; }) => {
//         setLocation({
//             loaded: true, error,
//         })
//     }
//     // const requestLocationPermission = () => {
//     //   navigator.geolocation.getCurrentPosition(onSuccess, onError);
//     // };
//
//
//     useEffect(() => {
//         // navigator 객체 안에 geolocation이 없다면
//         // 위치 정보가 없는 것.
//         if (navigator.geolocation) {
//             navigator.geolocation.getCurrentPosition(onSuccess, onError, {enableHighAccuracy: true});
//             // if (!("geolocation" in navigator)) {
//         } else {
//             console.log("위치정보가없습니다.")
//
//             onError({
//                 code: 0, message: "Geolocation not supported",
//             })
//         }
//
//         navigator.geolocation.getCurrentPosition(onSuccess, onError, {enableHighAccuracy: true});
//     }, [])
//
//     const refreshLocation = () => {
//         // setLocation({
//         //   loaded: false,
//         //   coordinates: { lat: 0, lng: 0 }
//         // });
//         navigator.geolocation.getCurrentPosition(onSuccess, onError, {enableHighAccuracy: true});
//     };
//
//     return {location, refreshLocation};
//
// }
//
// export default useGeolocation


import { useState, useEffect } from 'react';

interface locationType {
    loaded: boolean;
    coordinates?: { lat: number; lng: number };
    error?: { code: number; message: string };
}

const useGeolocation = () => {

    const [location, setLocation] = useState<locationType>({
        loaded: false,
        coordinates: { lat: 0, lng: 0, }
    })

    // 성공에 대한 로직
    const onSuccess = (position: { coords: { latitude: number; longitude: number; }; }) => {
        setLocation({
            loaded: true,
            coordinates: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            }
        })
    }

    // 에러에 대한 로직
    const onError = (error: { code: number; message: string; }) => {
        setLocation({
            loaded: true,
            error,
        })
    }
    // const requestLocationPermission = () => {
    //   navigator.geolocation.getCurrentPosition(onSuccess, onError);
    // };


    useEffect(() => {
        // navigator 객체 안에 geolocation이 없다면
        // 위치 정보가 없는 것.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(onSuccess, onError,{enableHighAccuracy:true});
            // if (!("geolocation" in navigator)) {
        }
        else {
            console.log("위치정보가없습니다.")

            onError({
                code: 0,
                message: "Geolocation not supported",
            })
        }

        navigator.geolocation.getCurrentPosition(onSuccess, onError,{enableHighAccuracy:true});
    }, [])

    const refreshLocation = () => {
        // setLocation({
        //   loaded: false,
        //   coordinates: { lat: 0, lng: 0 }
        // });
        navigator.geolocation.getCurrentPosition(onSuccess, onError,{enableHighAccuracy:true});
    };

    return { location, refreshLocation };

}

export default useGeolocation